import { render, staticRenderFns } from "./Managers.vue?vue&type=template&id=1b20410a&"
import script from "./Managers.vue?vue&type=script&lang=js&"
export * from "./Managers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports